const data = {
    "username": "Anuj Gosalia",
    "followers": 6482,
    "following": 245,
    "designation": "Co-founder & CEO at Terribly Tiny Tales",
    "instagram": "http://www.instagram.com/anujgosalia",
    "starred": 125,
    "likes": 12,
    "views": 57846,
    "hearts": 26025,
    "posts": [
        {
            "postHeading": "A Changing World Order",
            "content": "The world is changing at a feverish pace. Friends colleagues and everyone engaged in knowledge work are beginning to sense this, including colleagues and everyone engaged in knowledge work are beginning to sense this, including ",
            "type": "musing",
            "date": "August 2",
            "timeRead": 2,
            "views": 102
        },
        {
            "postHeading": "India v/s Australia",
            "content": "Think about it - this cricket series was akin to therapy. <br /> <br />Laying out childhook trauma up top, working with it slowly and surely over two months ",
            "type": "thought",
            "date": "January 21",
            "timeRead": 1,
            "views": 156
        },{
            "postHeading": "Write To Build",
            "content": "Writing is the first step to create:<br /> <br />- stories<br />- products<br />- companies",
            "type": "thought",
            "date": "November 18",
            "timeRead": 1,
            "views": 228,
        }
    ]
};

export default data;